/*** TRIVIA ***/

import { CLASSPREFIX } from "../config/constants"
import { TriviaOptions, AudioInterface, LoaderInterface, ResultInterface } from "../config/interfaces";

// Service
import { triviaService } from "../services/api";
const api = new triviaService()

declare global {
    interface Window {
        dataLayer: any
    }
  }

// Libraries
var _ = require('lodash');

// Modules
import Time from "./Time";
import Audio from "./Audio";
import Question from "./Question";
import Countdown from "./Countdown";
import Loader from "./Loader";
export default class Trivia {

    // CONSTANTS
    mainClass: string = `${CLASSPREFIX}-trivia`;
    summaryClass: string = `${this.mainClass}-summary`;

    // ELEMENTS
    targets: { [section: string]: HTMLElement; };
    questionsObject: Array<any> = [];
    sounds: { [audio: string]: AudioInterface };
    loader: LoaderInterface;
    events: { [event: string]: CustomEvent };

    // VARS
    triviaId: string;
    triviaOptions: TriviaOptions;
    counter: any;
    currentQuestionId: number = 0;

    // RESPONSE FROM BACK
    results: ResultInterface;

    constructor(triviaId: string, triviaOptions: TriviaOptions) {
        this.triviaId = triviaId;
        this.triviaOptions = triviaOptions;
        this.loader = new Loader(`${triviaId} .${CLASSPREFIX}-loader`);

        this.sounds = {
            backgroundAudio: new Audio('backgroundAudio', { fileName: 'countdown.mp3' }),
            failAudio: new Audio('failAudioQuestionOption', { fileName: 'lose.mp3' }),
            successAudio: new Audio('successAudioQuestionOption', { fileName: 'correct.mp3' }),
            clicAudio: new Audio('audioQuestionOption', { fileName: 'clic.mp3' })
        }
        this.targets = {
            mainContainer: document.querySelector(`${this.triviaId}`),
            welcomeContainer: document.querySelector(`${triviaId} .${this.mainClass}__welcome`),
            questionContainer: document.querySelector(`${triviaId} .${this.mainClass}__questions`),
            finalContainer: document.querySelector(`${triviaId} .${this.mainClass}__final`),
            questionIndicator: document.querySelector(`${triviaId} .${this.mainClass}__current-question`),
            startTriviaBtn: document.querySelector(`${triviaId} .${this.mainClass}-start-button`),
            summaryContainer: document.querySelector(`${triviaId} .${this.summaryClass}`),
        }

        this.createEvents({ name: 'onLoadTrivia' })
        this.createEvents({ name: 'onTriviaDone' })
        this.init()
    }

    init() {
        let { welcomeContainer, questionContainer } = this.targets
        let { welcomePage, nextButton, questions } = this.triviaOptions

        // OCULTA LA PANTALLA DE BIENVENIDA
        !welcomePage && welcomeContainer.classList.add(`${this.mainClass}-section--hidden`)

        // PREGUNTAS EN ORDEN ALEATORIO
        let shuffleQuestion = _.shuffle(questions)

        // CREA EL MARKUP, AGREGA LAS PREGUNTAS AL DOM, Y ASIGNA UN EVENTO QUE ESCUCHA LA OPCION SELECCIONADA
        shuffleQuestion.forEach(({ id, title, type, answers }: any, index: number) => {

            // EN CASO DE QUE NO EXISTA UN BOTON DE SIGUIENTE (nextButton)
            // AL SELECCIONAR UNA OPCION DE RESPUESTA SE CAMBIARA AUTOMATICAMENTE DE PREGUNTA
            let nwQuestion =
                nextButton ?
                    new Question(id, { title, type, answers }) :
                    new Question(id, { title, type, answers, onSelectedOption: () => this.changeQuestion() })
            questionContainer.insertAdjacentHTML('beforeend', nwQuestion.createQuestionContainer(index))
            nwQuestion.setHandlerEvents()

            this.questionsObject = [...this.questionsObject, nwQuestion]
        })

        this.setHandlerEvents()

        // MUESTRA LA PANTALLA FINAL EN CASO DE QUE LA TRIVIA SE ENCUENTRA HECHA
        this.requestData()
    }

    // ASIGNA EVENTOS A LOS ELEMENTOS
    setHandlerEvents() {
        let { nextButton } = this.triviaOptions
        let { questionContainer, startTriviaBtn } = this.targets

        // BOTON DE SIGUIENTE
        if (nextButton) questionContainer.insertAdjacentElement('beforeend', this.createNextButton(nextButton))

        // BOTON DE INICIAR TRIVIA
        if (startTriviaBtn) startTriviaBtn.addEventListener('click', () => this.startTrivia())
    }

    // INICIA LA TRIVIA
    startTrivia() {
        let { questionContainer } = this.targets
        let { backgroundAudio, failAudio } = this.sounds
        let { timer } = this.triviaOptions

        // backgroundAudio.playAudio();
        this.activeSection(questionContainer)

        // INICIALIZA EL CONTADOR SOLO SI SE PASA UN TIMER
        if (timer) {
            this.counter = new Countdown(timer, {
                onOverTime: (e: any) => {
                    failAudio.playAudio()
                    this.sendData()
                }
            })
            questionContainer.insertAdjacentElement('afterbegin', this.counter.createProgressContainer())
        }
        this.createIndicatorQuestion()

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'GAEvent',
            'event_category': 'Quiz',
            'event_action': 'Start',
            'event_label': 'Trivia PreConcert', 
            'interaction':'true',
            'component_name': 'Enviar Trivia',
            'campaign_description': 'Pre Concert Bud', 
            'cupom_description': 'cupom_description'
        })
    }

    // ACTIVA O DESHABILITA SECCIONES (WELCOME/QUESTION/FINAL)
    activeSection(nwSection?: HTMLElement) {
        let refActiveSection: HTMLElement = document.querySelector(`${this.triviaId} .${this.mainClass}-section--active`)

        if (refActiveSection) {
            refActiveSection.classList.remove(`${this.mainClass}-section--active`)
            refActiveSection.classList.add(`${this.mainClass}-section--disable`)
        }

        if (nwSection) {
            nwSection.classList.remove(`${this.mainClass}-section--disable`)
            nwSection.classList.add(`${this.mainClass}-section--active`)
        }
    }

    // VERIFICA SI SE HA ESCOGIDO ALGUNA OPCION EN LA PREGUNTA ACTUAL
    isSelectedOption() {
        let currentQuestion = this.questionsObject[this.currentQuestionId]
        if (currentQuestion && currentQuestion.optionSelected) return true
        return false
    }

    // CAMBIA DE PREGUNTA
    changeQuestion() {
        let { clicAudio, failAudio } = this.sounds
        let { questionContainer } = this.targets

        if (this.isSelectedOption()) {
            clicAudio.playAudio()

            this.currentQuestionId = this.currentQuestionId += 1
            this.updateIndicatorQuestion()

            // OCULTA LA PREGUNTA RESPONDIDA
            let activeQuestion = questionContainer.querySelector(`.${this.mainClass}__question--active`)
            activeQuestion.classList.remove(`${this.mainClass}__question--active`)

            // MUESTRA LA NUEVA PREGUNTA
            let nextQuestion = this.questionsObject[this.currentQuestionId]
            if (nextQuestion && nextQuestion.targetQuestion.classList.contains(`${this.mainClass}__question`))
                nextQuestion.targetQuestion.classList.add(`${this.mainClass}__question--active`);

            // MUESTRA LA ULTIMA SECCION (RESULTADOS/RESUMEN DE LA TRIVIA)
            if (this.currentQuestionId == this.triviaOptions.questions.length) {
                this.counter && this.counter.stopCounter()
                this.sendData()
            }
        }
        else {
            failAudio.playAudio()
        }
    }

    // MUESTRA LA ULTIMA SECCION
    endTrivia() {
        let { backgroundAudio } = this.sounds;

        // backgroundAudio.stopAudio();
        this.activeSection()
        this.loader.setVisibility('show')

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'GAEvent',
            'event_category': 'Quiz',
            'event_action': 'Finish',
            'event_label': 'Trivia PreConcert', 
            'interaction':'true',
            'component_name': 'Terminar trivia',
            'campaign_description': 'PreConcert Bud', 
            'cupom_description': 'cupom_description'

        })

        let container = document.querySelector('.ctm-150-trivia__final') as any;
        
        if(container){
            let fondo = document.querySelector('.fondoRojo') as any;
            if(fondo){
                fondo.style.display = 'block';
            }
        }

    }

    // MUESTRA EL RESUMEN DE LA TRIVIA (PREGUNTAS ACERTADAS Y TIEMPO)
    async showSummary() {
        let { summaryContainer, finalContainer } = this.targets
        let { successAudio } = this.sounds
        let { questions, timer } = this.triviaOptions
        
        const getPersonalRanking: any = await api.getRankingData()
        console.log(getPersonalRanking.my_ranking)

        const boxpersonalRanking = document.getElementById('personalRanking') as HTMLElement;

        if(boxpersonalRanking){
            boxpersonalRanking.innerHTML = `<p class="position">${getPersonalRanking.my_ranking.pos ? getPersonalRanking.my_ranking.pos : '--'}</p>
            <p class="name">${getPersonalRanking.my_ranking.name ? getPersonalRanking.my_ranking.name : '--'}</p>
            <p class="time">${this.calculateTime(getPersonalRanking.my_ranking.left_time ? getPersonalRanking.my_ranking.left_time : '00')}</p>
            <p class="score">${getPersonalRanking.my_ranking.points ? getPersonalRanking.my_ranking.points : '--'} PTS</p>
            `;
        }
            
        let questionMarkup = `<h3 class="${this.summaryClass}__questions">Acertaste: <span class="boxG"><span>${this.results.correct}/${questions.length}</span> preguntas</span></h3>`
        let timeMarkup = !timer ? '' : `<h3 class="${this.summaryClass}__time">Tu tiempo fue de: <span class="boxG">${this.counter ? this.counter.timeStringUsedTime : this.results.timeString}</span></h3>`
        summaryContainer.insertAdjacentHTML("beforeend", `${questionMarkup}${timeMarkup}`)

        this.loader.setVisibility('hide')
        this.activeSection(finalContainer)
        successAudio.playAudio()

        this.showSummaryAditional()
    }

    //  CONVIERTE MILISEGUNDOS EN MINUTOS, SEGUNDOS Y MILISEGUNDOS
    calculateTime(mSecs: any) {
        let mi = Math.floor(mSecs / 1000 / 60);
        let ss = Math.floor((mSecs / 1000) % 60);
        let ms = Math.floor(mSecs % 1000);
    
        const fillZero = (time: any) => {
          return time < 10 ? `0${time}` : `${time}`;
        };
    
        return `${fillZero(mi)}:${fillZero(ss)}:${fillZero(ms)}`;
    }

    // MUESTRA INFORMACION ADICIONAL AL FINALIZAR LA TRIVIA
    showSummaryAditional() {
        let refAditional = document.querySelector(`${this.triviaId} .${CLASSPREFIX}-winner-points`)
        let markup = ` <p>Ganaste</p><span>+${this.results.points} PTS</span>`
        refAditional && refAditional.insertAdjacentHTML('beforeend', markup)
    }

    createEvents(nwEvent: { name: string, params?: any }) {
        this.events = { ...this.events, [nwEvent.name]: new CustomEvent(nwEvent.name, nwEvent.params) }
    }

    // CREA EL NUMERO PREGUNTA ACTUAL (PREGUNTA X DE Y)
    createIndicatorQuestion() {
        let { questionContainer } = this.targets
        let nwIndicator: HTMLElement = document.createElement('span')
        nwIndicator.classList.add(`${CLASSPREFIX}-trivia__current-question`)
        questionContainer.insertAdjacentElement('afterbegin', nwIndicator)

        this.targets.questionIndicator = nwIndicator
        this.updateIndicatorQuestion()
    }

    // ACTUALIZA EL NUMERO PREGUNTA ACTUAL
    updateIndicatorQuestion() {
        let { questionIndicator } = this.targets
        questionIndicator.innerHTML = `Pregunta ${this.currentQuestionId + 1} de ${this.triviaOptions.questions.length}`
    }

    // CREA EL BOTON DE SIGUIENTE
    createNextButton(textButton: string): HTMLButtonElement {
        let nwButton: HTMLButtonElement = document.createElement('button');
        nwButton.innerHTML = textButton;
        nwButton.classList.add(`${this.mainClass}__next-button`);
        nwButton.addEventListener('click', () => this.changeQuestion())
        return nwButton
    }

    // CONSULTA Y ESTABLECE EL RESUMEN DE LA TRIVIA
    async requestData() {
        let { mainContainer, welcomeContainer, finalContainer } = this.targets
        let { welcomePage } = this.triviaOptions
        let { onLoadTrivia, onTriviaDone } = this.events
        const responseTrivia: any = await api.triviaIsDone()
        // const responseTrivia = {count: 0, error: false}
        console.log(responseTrivia);

        this.loader.setVisibility('hide')

        // SI NO HAY USUARIO LOGEADO MUESTRA LA PANTALLA DE BIENVENIDA
        if (!responseTrivia.count && responseTrivia.error) return this.activeSection(welcomeContainer)

        // MUESTRA LA ULTIMA SECCION EN CASO DE QUE YA SE HAYA RESUELTO LA TRIVIA
        // DE LO CONTRARIO MUESTRA LA PANTALLA DE BIENVENIDA
        if (responseTrivia && responseTrivia.count > 0) {
            // let counter = new Time()
            // this.results = { ...responseTrivia, timeString: counter.calculateTime(responseTrivia.time) }
            // this.endTrivia()
            // this.showSummary()
            // this.activeSection(finalContainer)

            // DISPARA EVENTO SI SE HA CONTESTADO LA TRIVIA PREVIAMENTE
            mainContainer.dispatchEvent(onTriviaDone)
        }
        else {
            welcomePage ? this.activeSection(welcomeContainer) : this.startTrivia()
        }

        // DISPARA EVENTO AL CARGAR LA TRIVIA
        mainContainer.dispatchEvent(onLoadTrivia)
    }

    // ENVIA LA INFORMACION DE TRIVIA
    async sendData() {
        let { triviaPrefix } = this.triviaOptions;
        let { endTime } = this.counter;
        let questionResponse: any;
        this.questionsObject.forEach(question => questionResponse = { ...questionResponse, [question.id]: question.optionSelected })

        this.endTrivia()
        const responseTrivia: any = await api.sendTriviaResponse({
            prefix: triviaPrefix,
            left_time: endTime,
            ...questionResponse
        })
        this.results = responseTrivia
        this.showSummary()
    }
}